import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

type BadgeVariant = 'solo' | 'pro' | 'success' | 'warn' | 'danger' | 'neutral';

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
  solo: 'bg-ducens-accent-tint text-ducens-ink border-ducens-accent',
  pro: 'bg-ducens-pro-tint text-ducens-pro border-ducens-pro/40',
  success: 'bg-green-50 text-ducens-success border-ducens-success/40',
  warn: 'bg-orange-50 text-ducens-warn border-ducens-warn/40',
  danger: 'bg-red-50 text-ducens-danger border-ducens-danger/40',
  neutral: 'bg-ducens-bg text-ducens-muted border-ducens-border',
};

export function Badge({
  variant = 'neutral',
  children,
  className,
}: {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 text-xs font-semibold uppercase tracking-wide rounded-full border',
        VARIANT_CLASSES[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
